import { FormOtherOptionsModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class OtherOptionsEditor extends AbstractElementEditor<FormOtherOptionsModel> {
  public getDescription(): string {
    return 'Include all other options not directly listed';
  }

  public getName(): string {
    return 'Other Options';
  }

  public getIcon(): string {
    return 'dynamic_feed';
  }
}
